<template>
  <div>
    <v-container grid-list-xl fluid>
      <div v-if="alerta">
        <alert-empty></alert-empty>
      </div>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="nivelValue"
                    :items="nivelSelect"
                    label="Nivel"
                    data-vv-name="listaNiveles"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="regionValue"
                    :items="regionSelect"
                    label="Region"
                    item-text="nombre"
                    item-value="code"
                  ></v-select>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar contratos"
                  @click="filterProv()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
              <v-layout class="d-flex pa-2">
                <div class="d-flex pa-2" xs12 sm6>
                  <v-text-field
                    width="300px"
                    v-model="txtBusqueda"
                    placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
                    single-line
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    @click="loadData()"
                    :disabled="txtBusqueda.length < 3"
                    class="shrink"
                    ><v-icon dark left>search</v-icon>Buscar</v-btn
                  >
                  <v-btn
                    color="secondary"
                    @click="clear()"
                    :disabled="txtBusqueda.length < 3"
                    class="shrink"
                    ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
                  >
                </div>
              </v-layout>
            </v-container>
            <!-- TABLA PROVEEDORES -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-documento-diario-progreso
                :itemsDocumento="itemsDocumento"
              ></grid-documento-diario-progreso>
            </template>
            <!-- TABLA PROVEEDORES -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import GridDocumentoDiarioProgreso from "@/modules/distribucion/views/progreso/GridDocumentoDiarioProgreso.vue";
import Loading from "@/views/ui/Loading.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "progreso-diario-tab",
  components: {
    GridDocumentoDiarioProgreso,
    AlertEmpty,
    Loading,
    DataAdjunto,
  },
  props: {
    tabSelected: "",
  },
  data() {
    return {
      loading: false,
      proveedor: {},
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      itemsDocumento: [],
      txtBusqueda: "",
      nivelSelect: [],
      regionSelect: [],
      nivelValue: null,
      regionValue: null,
      filter: false,
      proceso: "",
      alerta: false,
    };
  },

  mounted() {
    this.loadData();
  },

  created() {},
  methods: {
    async loadDocumentosFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        subProceso: subProceso,
        idContrato: idContrato,
        txtBusqueda: this.txtBusqueda,
      };
      return await axios
        .post("/progreso/distribucion/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadDocumentosFilter();
      if (this.itemsDocumento.length > 0) {
        this.loadNivelSelect();
        this.loadRegionSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    /*   limpiaBuscador()
    {
      this.txtBusqueda = "";
      this.loadData();
    }, */

    loadNivelSelect() {
      let niv = [];
      this.itemsDocumento.forEach(function (d) {
        let index = niv.findIndex((x) => x.nivel == d.nivel);
        if (index === -1) {
          if (d.nivel != null && d.nivel != "") {
            niv.push(d.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadRegionSelect() {
      let tipM = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tipM.findIndex((x) => x.region == d.region);
        if (index === -1) {
          if (d.region != null && d.region != "") {
            tipM.push(d.region);
          }
        }
      });
      this.regionSelect = tipM;
    },
    clear() {
      this.nivelValue = "";
      this.regionValue = "";
      this.txtBusqueda = "";
      this.loadData();
    },
    loadSelected() {},
    selected(tab) {
      this.tabSelect = tab;
    },
    filterProv() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
